import { map, filter } from 'rxjs/operators'
import turbolinksLoadedObservable from './turbolinksLoadedObservable'

const controllerLoadedObservable = turbolinksLoadedObservable.pipe(
  map(() => {
    const loadedControllerName = $('body').data('javascript-folder')
    return loadedControllerName
  }),
)

export default (expectedControllerName) =>
  controllerLoadedObservable.pipe(
    filter(
      (currentControllerName) =>
        currentControllerName === expectedControllerName,
    ),
  )
